/* 🤖 this file was generated by svg-to-ts */
export const matIconSource: {
  name: 'source';
  data: string;
} = {
  name: 'source',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2-6H6v-2h12v2zm-4 4H6v-2h8v2z"/></svg>`
};
